export let useMenuStore = defineStore('menu', () => {
  let active = ref(false)

  return {
    active,
  }
})
